const $ = require("jquery");
window.$ = window.jQuery = $

require("./version.js");
require("./acer/interactive-asset-events.js");
require("./acer/acer-delivery-service.js");
let i18n = require('./i18n.js');
import * as test from "/items/test.json";
import "../css/pisa2025.css";
import ItemManager from "./components/ItemManager.js";

window.Pisa2025Loader = new class {

  constructor() {
    this.init();
  }

  async init() {
    let me = this,
    params = new URLSearchParams(window.location.search);

    me.unit = params.get('unit');
    me.itemId = params.get('item');
    me.language = params.get('lang');
    me.userid = params.get('userid');

    if (me.itemId != null) {

      // we have to do it this way for now in order to work with Parcel
      switch (me.unit) {
        case "Conservation": me.template = await (await import("/items/Conservation_template.js")).template(me.itemId); break;
      }
      
      me.initItem();
    } else if (!me.inDeliveryMode()) {
      $(function () {
        me.showIndex();
      });
    }
  }

  initItem() {
    let me = this;

    //set the title and append the content to the page
    $('#g-item-manager').append($($.parseHTML(this.template)));

    // make sure the appended content has loaded/rendered
    $(function () {
      let task = $('#task');

      let iId = window.Pisa2025Loader.itemId,
          unitNs = 'u'+iId.charAt(3);

      i18n.i18n.init(window.Pisa2025Loader.language, ['common', unitNs, unitNs+'-'+iId.substring(4)]).then(function() {

        // allow registering classes at the individual task level
        ItemManager.types.forEach((type) => {
          if (task.hasClass(type.cls)) {
            $('#g-item-manager').addClass(type.cls);
          }
        });

        if (!me.inDeliveryMode()) {
          me.registerDevEvents();
          let state = me.userid == null ? '{"global":{"timer":false}}' : '{"global":{"userid":"'+me.userid+'"}}'
          ItemManager.setState(state);
        } else {
          ItemManager.setState('');
          window.ACERDeliveryService.init(me.itemId, me.unit, test);
        }
      });
    });
  }

  getTimeoutNextItem() {
    let me = this;

    for (let i=0; i < test[me.unit].length; i++ ) {
      let currPos = test[me.unit][i].items.findIndex(e => e.id == me.itemId);
      if (currPos != -1) {
        return (test[me.unit].flatMap(e=>e.items).findIndex(e => e.id == me.itemId))+test[me.unit][i].items.length-currPos
      }
    }

    return -1;
  }

  registerDevEvents() {
    let me = this;

    let flatTest = test[me.unit].flatMap(e=>e.items);
    let currItem = flatTest.findIndex(e => e.id == me.itemId);

    $('#g-item-manager').on('goto-position', (e) => {
      let pos = e.pagePosition;

      if (pos == 'NEXT_SECTION') {
        pos = me.getTimeoutNextItem();
      }
      window.location = `?unit=${me.unit}&item=${flatTest[pos].id}${me.language == null ? "" : "&lang="+me.language}${me.userid == null ? "" : "&userid="+me.userid}`;
    });
    
    $('#g-item-manager').on('continue', () => {
      // useful for testing in dev
        //console.log(ItemManager.getState());

      // if we have more items
      if (currItem < flatTest.length - 1) {
        window.location = `?unit=${me.unit}&item=${flatTest[currItem + 1].id}${me.language == null ? "" : "&lang="+me.language}${me.userid == null ? "" : "&userid="+me.userid}`;
      }
    });
    $('.g-next').toggle(currItem < flatTest.length - 1);

    $('.g-previous').on('click', function () {
      //Sonet.am.scorm.PISA2025.finish();
      currItem = flatTest.findIndex(e => e.id == me.itemId);
      // if we have more items
      if (currItem > 0) {
        window.location = `?unit=${me.unit}&item=${flatTest[currItem - 1].id}${me.language == null ? "" : "&lang="+me.language}${me.userid == null ? "" : "&userid="+me.userid}`;
      }
    }).toggle(currItem > 0);

    $('.g-previous').removeClass('g-hide');
  }

  inDeliveryMode() {
    return window.parent && window.parent.Delivery;
  }

  showIndex() {
    let me = this;

    $('#g-item-manager').append(`
      <div style="padding: 16px;">
        <h1>Introduction screen for students who sit PISA 2025 Learning in the Digital World</h1>
        <br>
        <h2>Welcome to Learning in the Digital World!</h2>
        <p>
          You will work through two 30-minute modules. Each unit has three parts:
        </p>
        <ol>
          <li>Show: answer some multiple-choice questions to show what you already know</li>
          <li>Learn: use digital tools to learn and solve simple interactive problems</li>
          <li>Apply: use what you have learnt to solve a more complex problem.</li>
        </ol>
        <p>
          In this test, you are encouraged to check your work and use examples to help you.
          You may not complete all problems in the time you have. You will be awarded credit for any
          progress you make towards a solution!
        </p>
        <h2>Select NEXT to continue.</h2>
        <a href="/?unit=Conservation&item=P1M401">NEXT &rarr;</a>
      </div>
    `)

    const renderUnit = (unit) => {
      let listElem = '';

      test[unit].flatMap(e=>e.items).forEach((item) => {
        listElem += `<li><a href="?unit=${unit}&item=${item.id}${me.language == null ? "" : "&lang="+me.language}${me.userid == null ? "" : "&userid="+me.userid}">[${item.id}] ${item.title}</a></li>`;
      });

      $('#g-item-manager').append(
        `<div class="g-unit">
          <h1>${unit}</h1>
          <ul>${listElem}</ul>
        </div>`
      );
    }

    if (!me.unit) {
      Object.entries(test).forEach(([k, u]) => {
          renderUnit(k);
      });
    } else {
      renderUnit(me.unit);
    }

    $('#g-item-manager').addClass('g-load-complete g-index');
  }
}